"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DefaultManifestLoader = (function () {
    function DefaultManifestLoader() {
    }
    DefaultManifestLoader.prototype.notifyNativeLoad = function (nativeLoadData) {
    };
    DefaultManifestLoader.prototype.getManifest = function () {
        throw new Error('Cannot load manifest: no manifest loader provided');
    };
    return DefaultManifestLoader;
}());
exports.DefaultManifestLoader = DefaultManifestLoader;
